export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '8a886506-368f-492c-a3a8-614088459068';
export const MODAL_CLOSE_SEC = 2.5;
